/**
 * CSPRNG wrapper. Uses WebCrypto `crypto.getRandomValues` (browser) which is
 * also present on Node ≥ 19 `globalThis.crypto`. Never `Math.random()`.
 *
 * A test-only `__setRandomSource` hook lets property tests pin nonces to
 * reproduce a failing seed. It is NOT exported from the public barrel.
 */
import { RngUnavailableError } from './errors.js';
let source = (() => {
    const c = globalThis.crypto;
    if (c !== undefined && typeof c.getRandomValues === 'function') {
        return (buf) => {
            c.getRandomValues(buf);
        };
    }
    return undefined;
})();
/** Return `n` cryptographically-random bytes. */
export function randomBytes(n) {
    if (source === undefined) {
        throw new RngUnavailableError();
    }
    const buf = new Uint8Array(n);
    source(buf);
    return buf;
}
/**
 * Test-only: override the random source for deterministic property replays.
 * Pass `undefined` to simulate a host without a CSPRNG. Restore by passing the
 * value returned from the first call.
 * @internal
 */
export function __setRandomSource(fn) {
    const prev = source;
    source = fn;
    return prev;
}
//# sourceMappingURL=random.js.map